import { render, staticRenderFns } from "./CustomerDetailCardstack.vue?vue&type=template&id=fee261bc"
import script from "./CustomerDetailCardstack.vue?vue&type=script&lang=js"
export * from "./CustomerDetailCardstack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports